module.exports = __webpack_public_path__ + "static/media/vignette-cover.a1f31fae.jpg";